
import {
  Row,
  Col,
  Button,
  ButtonGroup,
}from 'react-bootstrap';

import {
  Label,
  Audio,
  ListView,
}from '../';

import { COLOR, LANG } from '../../const';

var React = require('react');
var Radium = require('radium');
var FontAwesome = require('react-fontawesome');
var HelperScripts = require('../../utils/HelperScripts.js');

class AnalyzeAct extends React.Component {
  render() {
    return(
      <div>
        <Row>
          <ListView {...this.props}>
            {this.props.progressList.map(item => (
              <AnalyzeItem
                key={item.word}
                item={item}
                isCorrect = {item.isCorrect}
                wasChecked = {item.wasChecked}
                {...this.props}
              />
            ))}
          </ListView>
        </Row>
      </div>
    )
  }
}

class AnalyzeItem extends React.Component {

  constructor(props){
    super(props);

    this.state = {
      optionsSyllables: [],
      optionsLetters: [],
      syllablesCorrect: false,
      lettersCorrect: false,
      syllablesChecked: false,
      lettersChecked: false,
    };
  }

  playAudio = () => {
    this.audio.onPlay();
  }

  componentDidMount(){
    //console.log(this.state.options.length);
    const {optionsSyllables, optionsLetters} = this.state;
    const {optionsSyllables: prevOptionsSyllables, optionsLetters: prevOptionsLetters } = this.props.item.props;
    if ((prevOptionsSyllables || prevOptionsLetters) && (!optionsLetters.length || !optionsSyllables.length)){
      this.restoreOptions();
    }else{
        if (!optionsSyllables.length) {
          this.setOptionsSyllables();
        }
        if(!optionsLetters.length) {
          this.setOptionsLetters();
        }
    }
  }

  restoreOptions = () => {

    const {optionsSyllables, optionsLetters, lettersChecked, syllablesChecked} = this.props.item.props;

    this.setState({
      optionsSyllables: optionsSyllables,
      optionsLetters: optionsLetters,
      lettersChecked: lettersChecked,
      syllablesChecked: syllablesChecked,
    })
  }

  setOptionsSyllables = () => {
    const {item, progressList, language} = this.props;

    //If no word, stop
    if (!item) return;

    let numSyllables = -1;

    switch (language) {
      case LANG.EN:
          numSyllables = HelperScripts.SyllablesEng(item.word);
        break;
      case LANG.ES:
          numSyllables = HelperScripts.SyllablesEs(item.word);
        break;
    }

    if (numSyllables === -1) {
      console.log("ERROR: Language for this activity not supported");
    }

    //Options
    let option = [{}];

    option[0] = {
      val: numSyllables,
      isCorrect:true,
    };

    for (var i = 1; i < 3; i++) {
      option[i] = {
        val: this.randomNumber(1,5,option),  //random value between 1-5
        isCorrect : false,
      };
    }

    option = HelperScripts.ShuffleArray(option);

    //Error handling
    if (!option) {
      console.log(`ERROR: Options for item with word ${item.word} are empty!`);
      return;
    }
    //Assign
    this.setState({
      optionsSyllables: option,
    });
  }

  setOptionsLetters = () => {
    const {item, progressList} = this.props;

    //If no word, stop
    if (!item) return;

    let numLetters = -1;

    numLetters = HelperScripts.NumLetters(item.word);

    if (numLetters === -1) {
      console.log("ERROR: Language for this activity not supported");
    }

    //Options
    let option = [{}];

    option[0] = {
      val: numLetters,
      isCorrect:true,
    };

    for (var i = 1; i < 3; i++) {

      let val = this.randomNumber(1,15,option);

      option[i] = {
        val: val,  //random value between 1-15
        isCorrect : false,
      };
    }

    option = HelperScripts.ShuffleArray(option);

    //Error handling
    if (!option) {
      console.log(`ERROR: Options for item with word ${item.word} are empty!`);
      return;
    }
    //Assign
    this.setState({
      optionsLetters: option,
    });
  }

  handleAnswerClick = (type , correct) => {
    const {item} = this.props;

    if (this.props.wasChecked) return;

    if (this.state.lettersChecked && type === "letters") return;
    if (this.state.syllablesChecked && type === "syllables") return;

    //Apply according to type
    switch (type) {
      case "letters":
        this.setState({
          lettersChecked: true,
          lettersCorrect: correct,
        },this.checkIfComplete)
        break;
      case "syllables":
        this.setState({
          syllablesChecked: true,
          syllablesCorrect: correct,
        },this.checkIfComplete)
        break;
    }
  }

  checkIfComplete = () => {
    const {syllablesChecked, syllablesCorrect, lettersChecked, lettersCorrect} = this.state;
    console.log(`syllablesChecked: ${syllablesChecked} , lettersChecked: ${lettersChecked}, wasChecked: ${this.props.wasChecked}`);
    //If we have checked both
    if (syllablesChecked && lettersChecked && !this.props.wasChecked){
      //Right answer
      this.props.updateProgressList({
        word: this.props.item.word,
        isCorrect: (lettersCorrect && syllablesCorrect) ? true : false,
        wasChecked: true,
        optionsSyllables: this.state.optionsSyllables,
        optionsLetters: this.state.optionsLetters,
        lettersChecked: this.state.lettersChecked,
        syllablesChecked: this.state.syllablesChecked,
      })
    }
  }

  randomNumber = (initRange, finRange, toExclude) => {
    let rand = null;

    while(rand === null || toExclude.filter(x => x.val === rand).length !== 0){
      rand = Math.abs(Math.floor((Math.random()* finRange) + initRange));
    }

    return rand;
  }

  render() {

    const {container, header, sentence, footer, button, check} = styles.item.base;
    const {container: containerCorr , sentence: sentenceCorr} = styles.item.correct;
    const {container: containerNorm , sentence: sentenceNorm} = styles.item.notChecked;
    const {container: containerIncorr , sentence: senteceIncorr} = styles.item.incorrect;

    const {item, mode, toggleAudio, setAudioFalse, isAudioPlaying, updateProgressList, isCorrect, wasChecked} = this.props;

    return (
      <Col
        xs={12}
        md={4}
        style={
          styles.item.base
        }
      >
        <div style={[
          container,
          !isCorrect && !wasChecked && containerNorm,
          !isCorrect && wasChecked && containerIncorr,
          isCorrect && wasChecked && containerCorr,
        ]}>
          <Display
            labelWord={"Word"}
            labelSentence={"Sentence"}
            word={item.word}
            sentence={item.sentence}
          />
          <Label color="white" italic style={{marginLeft: '1.5rem', marginTop: '0.5rem'}} text={"Number of Syllables:"}/>
          <AnswerList
            options={this.state.optionsSyllables}
            handleAnswerClick={this.handleAnswerClick}
            wasChecked={this.state.syllablesChecked}
            type="syllables"
            style={styles.answerList}
          />
          <Label color="white" italic style={{marginLeft: '1.5rem', marginTop: '0.5rem'}} text={"Number of Letters:"}/>
          <AnswerList
            options={this.state.optionsLetters}
            handleAnswerClick={this.handleAnswerClick}
            wasChecked={this.state.lettersChecked}
            type="letters"
            style={styles.answerList}
          />

          <div style={footer}>
            <Button
              bsStyle={"success"}
              bsSize="lg"
              onClick={this.playAudio}
              style={button}
              block
               >
              <FontAwesome
                name="volume-up"
                inverse={true}
                size="lg"
              />
            </Button>
          </div>
          <Audio
            mode={mode}
            item={item}
            isAudioPlaying={isAudioPlaying}
            toggleAudio={toggleAudio}
            setAudioFalse={setAudioFalse}
            ref={(Audio) => {this.audio = Audio;}}
          />
        </div>
      </Col>
      )
  }
}

let Display = ({
      labelWord = "NewLabel",
      labelSentence = "NewLabel" ,
      word = "Lore",
      sentence = "Etsun blah blah blah blah blah"
      }) => (
  <div style = {styles.display.container}>
    <Label color="gray" italic style={{marginLeft: '0.5rem', marginTop: '0.5rem'}} text={labelWord}/>
    <h2 style = {styles.display.body}>{word}</h2>
    <Label color="gray" italic style={{marginLeft: '0.5rem', marginTop: '0.5rem'}} text={labelSentence}/>
    <h2 style = {{...styles.display.body, minHeight: '40px'}}>{sentence}</h2>
  </div>
)

Display = Radium(Display);
/***    -----------------------------
AnswerList Component

function: Component that will display an array of buttons with different answers, where some answers are false, and 1 is true.

In parameters = {
    options = [
      {
        val: integer,
        isCorrect: bool,
      }
    ],
    handleAnswerClick= fn(),
    wasChecked : bool,
}

Changes:
  - changes state of parent object through the to in fn() to props.item.props = {syllablesChecked : true, lettersChecked : true} .

***/

let AnswerList = ({options = [{val: 1, isCorrect: false}, {val: 2, isCorrect: true}],
                    handleAnswerClick,
                    wasChecked = false,
                    type = "letters",
                    style,
                  }) => {

  let key = 1;

  return(
  <ButtonGroup style={style}>
    {options.map(option => {

      let bsStyle, textStyle, buttonStyle;

      //Correct and checked
      if (option.isCorrect && wasChecked){
        textStyle = {...styles.item.correct.option};
        buttonStyle = {...styles.item.correct.optionBtn};
        bsStyle="success";
      //Incorrect and checked
      }else if (!option.isCorrect && wasChecked){
        textStyle = {...styles.item.incorrect.option};
        buttonStyle = {...styles.item.incorrect.optionBtn};
        bsStyle="danger";
      //Not checked
      }else{
        textStyle = {...styles.item.base.option};
        buttonStyle = {...styles.item.base.optionBtn};
        bsStyle="primary";
      }

      return(
        <Button
          key={++key}
          bsStyle={bsStyle}
          style={buttonStyle}
          bsSize="lg"
          onClick={() => handleAnswerClick(type,option.isCorrect)}
        >
          <div style={textStyle}>
            {option.val}
          </div>
        </Button>
        )
      })}
  </ButtonGroup>
  )
}

/* RADIUM WRAPPER */
AnswerList = Radium(AnswerList);
AnalyzeItem = Radium(AnalyzeItem);
/* ------------- */

const styles = {
  item: {
    base:{
      textAlign: 'center',
      marginBottom: '4rem',

      container: {
        borderRadius: '10px',
        minHeight: window.innerHeight * 0.3,
        display: 'flex',
        flexDirection: 'column',
      },
      header: {
        padding: '2rem',
      },
      footer: {
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        padding: '2rem',
      },
      button:{
        minWidth: '200px',
        marginTop: 'auto',
      },
      check: {
        minWidth: '200px',
      },
      option: {
        color: COLOR.blue,
      },
      optionBtn: {
        backgroundColor: COLOR.white,
      },
    },
    notChecked: {
      container: {
        borderColor: COLOR.blue,
        backgroundColor: COLOR.blue,
      },
    },
    correct: {
      container: {
        borderColor: COLOR.green,
        backgroundColor: COLOR.green,
      },
      option: {
        color: COLOR.white,
      },
      optionBtn: {
        backgroundColor: COLOR.green,
      },
    },
    incorrect: {
      container: {
        borderColor: COLOR.red,
        backgroundColor: COLOR.red,
      },
      option: {
        color: COLOR.red,
      },
      optionBtn: {
        backgroundColor: COLOR.white,
      },
    }
  },
  display:{
    container:{
      borderRadius: '10px',
      backgroundColor: COLOR.white,
      textAlign: 'center',
      padding: '0.5rem',
      margin: '2rem 2rem 0.25rem 2rem'
    },
    body:{
      fontSize: '18px',
      marginTop: '0.25rem',
      color: COLOR.grayText,
    },
  },
  answerList:{
    display:'flex',
    justifyContent: 'center',
  }

}

export default Radium(AnalyzeAct);



// WEBPACK FOOTER //
// ./src/comp/Activities/AnalyzeAct.js